import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function RedefinirSenha() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');

  const [senha, setSenha]       = useState('');
  const [confirma, setConfirma] = useState('');
  const [msg, setMsg]           = useState('');
  const [loading, setLoading]   = useState(false);

  const enviar = async e => {
    e.preventDefault();
    if (senha !== confirma) { setMsg('senhas_diferentes'); return; }
    setLoading(true);
    try {
      await api.post('/auth/redefinir-senha', { token, senha });
      setMsg('ok');
      setTimeout(() => navigate('/login'), 3000);
    } catch {
      setMsg('erro');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--ink)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <Link to="/" style={{ display:'flex', alignItems:'center', gap:12, marginBottom:36, justifyContent:'center' }}>
          <img src="/assets/heritage-logo-transparent.png" alt="Heritage" style={{ width:48, height:48, objectFit:'contain' }} />
          <span style={{ fontFamily:"'Playfair Display',serif", fontSize:22, color:'#fff', fontWeight:700 }}>Heritage BH</span>
        </Link>

        <div style={{ background:'#fff', borderRadius:'var(--r-md)', padding:'36px 40px', boxShadow:'var(--shadow-lg)' }}>
          <div className="eyebrow">Acesso</div>
          <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, fontWeight:600, marginBottom:8 }}>Nova senha</h1>
          <p style={{ fontSize:13, color:'var(--ink-muted)', marginBottom:26 }}>Escolha uma nova senha para sua conta.</p>

          {!token ? (
            <div className="alert alert-danger">Link inválido. Solicite uma nova recuperação de senha.</div>
          ) : msg === 'ok' ? (
            <div className="alert alert-success">Senha redefinida! Redirecionando para o login…</div>
          ) : (
            <form onSubmit={enviar}>
              {msg === 'erro' && <div className="alert alert-danger">Token inválido ou expirado. Solicite uma nova recuperação.</div>}
              {msg === 'senhas_diferentes' && <div className="alert alert-danger">As senhas não coincidem.</div>}
              <div className="form-group">
                <label>Nova senha</label>
                <input type="password" value={senha} onChange={e => setSenha(e.target.value)} minLength={6} required autoFocus />
              </div>
              <div className="form-group">
                <label>Confirmar senha</label>
                <input type="password" value={confirma} onChange={e => setConfirma(e.target.value)} minLength={6} required />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width:'100%', minHeight:50 }} disabled={loading}>
                {loading ? 'Salvando…' : 'Salvar nova senha'}
              </button>
            </form>
          )}
          <p style={{ textAlign:'center', fontSize:13, color:'var(--ink-muted)', marginTop:22 }}>
            <Link to="/login" style={{ color:'var(--rust)', fontWeight:900 }}>← Voltar ao login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
